/**
 * sd-category-showcase.js
 *
 * Category Showcase — IntersectionObserver reveal for the 3-card grid.
 * Recipe #1 (JS-first, all browsers). No animation-timeline.
 * Reduced motion: everything visible immediately.
 */

import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class SdCategoryShowcase extends Component {
  #io = null;

  connectedCallback() {
    super.connectedCallback();

    if (prefersReducedMotion()) {
      this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
      return;
    }

    this.#io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.#io?.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px' }
    );

    this.querySelectorAll('.reveal').forEach((el) => this.#io.observe(el));
  }

  updatedCallback() {
    super.updatedCallback?.();
    if (prefersReducedMotion()) return;
    this.querySelectorAll('.reveal:not(.is-visible)').forEach((el) => this.#io?.observe(el));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#io?.disconnect();
  }
}

if (!customElements.get('sd-category-showcase')) {
  customElements.define('sd-category-showcase', SdCategoryShowcase);
}
